import React from 'react';

import { RevealedNumber } from '@gumtree/shared/src/model/seller-contact-details.model';
import type { L1Category } from '@gumtree/shared/src/types/client-data';
import SellerPhoneReveal from './seller-phone-reveal';

import { sellerPhoneCss } from './seller-phone.style';

const SellerPhone: React.FC<Props> = ({
    revealPhone,
    replyPhone,
    revealedNumber,
    revealNumberUnmasked,
    isLoginRequiredToContactForVipCategory,
    showRevealNumber,
    revealPhoneCallbackUrl,
    isUserLoggedIn,
    pro,
    containsCallTrackingFeature,
    isStickyHeader,
    loginThenComeBack,
    l1CategorySeoName,
    requestId = '',
    adId = '',
    skipLoginToReveal,
}) => {
    const showDataQueue = true;
    let revealNumberUrl, phoneNumber;

    const haveRevealedNumber = !!(
        revealedNumber?.data &&
        !revealedNumber?.expired &&
        revealedNumber?.valid
    );

    if (haveRevealedNumber) {
        revealNumberUrl = '#';
        phoneNumber = revealedNumber.data;
    } else if (isLoginRequiredToContactForVipCategory && !showRevealNumber) {
        revealNumberUrl = revealPhoneCallbackUrl;
        phoneNumber = replyPhone;
    } else if (showRevealNumber) {
        revealNumberUrl = '#';
        phoneNumber = revealNumberUnmasked;
    } else {
        revealNumberUrl = '#';
        phoneNumber = replyPhone;
    }

    return (
        <div className="seller-phone" css={sellerPhoneCss}>
            {replyPhone && (
                <SellerPhoneReveal
                    phoneNumber={phoneNumber}
                    revealNumberUrl={revealNumberUrl}
                    revealNumberUnmasked={revealNumberUnmasked}
                    showDataQueue={showDataQueue}
                    isUserLoggedIn={isUserLoggedIn}
                    pro={pro}
                    containsCallTrackingFeature={containsCallTrackingFeature}
                    onClick={revealPhone}
                    isDisabled={haveRevealedNumber || showRevealNumber}
                    isStickyHeader={isStickyHeader}
                    loginThenComeBack={loginThenComeBack}
                    haveRevealedNumber={haveRevealedNumber}
                    l1CategorySeoName={l1CategorySeoName}
                    requestId={requestId}
                    adId={adId}
                    skipLoginToReveal={skipLoginToReveal}
                />
            )}
        </div>
    );
};

interface Props {
    revealPhone: (e) => void;
    replyPhone: string;
    revealedNumber: RevealedNumber;
    revealNumberUnmasked: string;
    showRevealNumber: boolean;
    revealPhoneCallbackUrl: string;
    isLoginRequiredToContactForVipCategory: boolean;
    isUserLoggedIn: boolean;
    pro: boolean;
    containsCallTrackingFeature: boolean;
    isStickyHeader: boolean;
    loginThenComeBack: () => void;
    l1CategorySeoName: L1Category;
    requestId?: string;
    adId?: string;
    skipLoginToReveal?: boolean;
}

SellerPhone.defaultProps = {
    replyPhone: '',
};

export default SellerPhone;
